<template>
  <SoSelect
    :model-value="modelValue"
    :items="items"
    type="simple"
    class="version-select"
    data-testid="version-select"
    @update:model-value="$emit('update:modelValue', $event as number)"
  >
    <template #selection="{ item }">
      <span class="font-weight-medium">Version {{ item.raw.version }}</span>
      <SoStatus :status="liveStatus(item.raw.isLive)" class="ml-2" />
    </template>
    <template #item="{ item, props }">
      <SoListItem v-bind="props" title="">
        <div class="d-flex align-center justify-space-between ga-6">
          <div class="d-flex align-center ga-2">
            <span class="font-weight-medium">
              Version {{ item.raw.version }}
            </span>
            <SoStatus :status="liveStatus(item.raw.isLive)" />
          </div>
          <span
            v-if="item.raw.createdAt"
            class="text-caption text-medium-emphasis"
          >
            {{ formatDateTime(item.raw.createdAt) }}
          </span>
        </div>
      </SoListItem>
    </template>
  </SoSelect>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoSelect from "@/components/formControls/SoSelect.vue"
  import SoListItem from "@/components/SoListItem.vue"
  import SoStatus from "@/components/SoStatus.vue"
  import { IStatus } from "@/types/Status"
  import { formatDateTime } from "@/helpers/dateHelper"
  import { IEmailTemplateVersionOption } from "@/models/admin/emailTemplates/emailTemplates.types"

  interface VersionItem extends IEmailTemplateVersionOption {
    title: string
    value: number
  }

  export default defineComponent({
    components: { SoSelect, SoListItem, SoStatus },
    props: {
      modelValue: {
        type: Number as PropType<number | null>,
        default: null,
      },
      versions: {
        type: Array as PropType<IEmailTemplateVersionOption[]>,
        default: () => [],
      },
    },
    emits: ["update:modelValue"],
    computed: {
      items(): VersionItem[] {
        return this.versions.map((version) => ({
          ...version,
          title: `Version ${version.version}`,
          value: version.id,
        }))
      },
    },
    methods: {
      formatDateTime,
      liveStatus(isLive: boolean): IStatus {
        return isLive
          ? { type: "normal", text: "Live" }
          : { type: "default", text: "Draft" }
      },
    },
  })
</script>

<style scoped>
  .version-select {
    min-width: 220px;
  }
</style>
